<div *ngIf="showBadges" class="product-badges-container">
  <lib-product-badge *ngIf="product?.productBadge" [productBadge]="product?.productBadge"></lib-product-badge>
  <lib-product-feature-badge
    *ngIf="hasMountedFramedPosters"
    [labelText]="'txt_mounted_framed_poster_available' | translate"
    [tooltipText]="'txt_mounted_framed_poster_available_tooltip' | translate"
  ></lib-product-feature-badge>
  <lib-product-feature-badge
    *ngIf="hasEmbroidery"
    [labelText]="'txt_embroidery_available' | translate"
    [tooltipText]="'txt_embroidery_available_tooltip' | translate"
  ></lib-product-feature-badge>
</div>
